import config from '@/config.js';

export default {
  data: config,
  async install(Vue) {
    Vue.prototype.$config = config;
  }
};
